import React from 'react';
import theme from '../../../theme';
import Typography from '@material-ui/core/Typography';

type PopupTableProps = React.HTMLAttributes<HTMLTableElement>;

const border = `1px solid ${theme.palette.grey[300]}`;

export default function PopupTable({children, style, ...props}: PopupTableProps) {

    if (React.Children.toArray(children).length === 0) return null;

    return <table
        style={{
            width: '100%',
            borderTop: border,
            marginTop: theme.spacing(1),
            ...style
        }}
        {...props}
    >
        <tbody>
            {children}
        </tbody>
    </table>;
}

interface PopupTableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
    label: string;
}

export function PopupTableRow({
    label,
    children,
    dangerouslySetInnerHTML,
    ...props
}: PopupTableRowProps) {

    return <tr {...props}>
        <Typography
            style={{
                borderBottom: border,
                margin: 0,
                paddingBottom: theme.spacing(0.5),
                paddingRight: theme.spacing(1),
                paddingTop: theme.spacing(0.5),
                verticalAlign: 'top',
                minWidth: 60
            }}
            component='td'
            variant='caption'
        >
            {label}
        </Typography>

        <td style={{borderBottom: border, margin: 0}}>
            <Typography
                variant='body2'
                style={{
                    // 106 shows half a line at the bottom of the element, suggesting to
                    // the user that it is scrollable
                    maxHeight: 106,
                    overflowY: 'scroll',
                }}
                dangerouslySetInnerHTML={dangerouslySetInnerHTML}
            >
                {children}
            </Typography>
        </td>
    </tr>;
}
